import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { SearchProfile } from "@/types";
import { GET_SEARCH_PROFILE } from "@/constants";

export const useGetSearchProfiles = () =>
  useQuery({
    queryKey: ["search-profiles"],
    queryFn: () =>
      axios.get<SearchProfile[]>(`${GET_SEARCH_PROFILE}`).then((res) => {
        return res.data;
      }),
    refetchOnWindowFocus: false,
    staleTime: 0,
  });
